import { css } from '@emotion/react';

export const root = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8.4rem;
`;
